import { getExpiryDate } from './utils'

export const companyInitialState = {
  company: null,
  companyExp: null,
}

export const COMPANY_ACTIONS = {
  SET_COMPANY: 'SET_COMPANY',
}

export const companyActions = {
  [COMPANY_ACTIONS.SET_COMPANY]: (_, { company }) => ({
    company,
    companyExp: getExpiryDate(),
  }),
}
